import { NavBar } from "../component/NavBar.jsx"
import { SideBar } from "../component/SideBar.jsx"

export const CompaniesPage = ()=>{
    return (
        <div>
        <NavBar/>
        <SideBar/>
        <div className="container">Companies content </div>
        
        </div>
    )
};